import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Helmet } from "react-helmet";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Container, Row } from "reactstrap";
import Layout from "../../components/layout";
import s from "./styles.scss";
import TestComponent from "./testComponent/testComponent";

interface Props extends RouteComponentProps {}

interface State {}

class TestPage extends React.Component<Props, State> {
  render() {
    return (
      <Layout>
        <Container>
          <Helmet title="Inicio" />
          <Row className={"my-3"}>
            {/* <CamMultiCapture /> */}
            <TestComponent />
          </Row>
        </Container>
      </Layout>
    );
  }
}

export default withRouter(withStyles(s)(TestPage));
